<template>
  <div>
    <v-dialog
      persistent
      fullscreen
      v-model="value"
      scrollable
    >
      <v-card>
        <v-toolbar
          dark
          color="gradiente"
        >
          <v-btn
            icon
            dark
            @click="close"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{isEnrolled ? "Inscripciones" : "Detalles"}}</v-toolbar-title>
        </v-toolbar>
        <v-container
          fluid
          style="max-height: 93vh;"
          class="scrollDesign"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs6
            >
              <div>
                <span class="title">{{ getWorkshopName() }}</span>
              </div>
              <div>
                <span class="subtitle">Descripción</span> 
              </div>
              <br>
              <div>
                <span class="content-data">{{ getWorkShopDescription() }}</span> 
              </div>
              <br>
              <div>
                <span class="subtitle">Fechas del taller</span> 
              </div>
              <div class="w-100 mt-3">
                <v-layout
                  wrap
                  row
                >
                  <!-- <v-flex
                    xs12
                    md2
                    class="mt-2"
                  >
                    <div
                      class="image-circle"
                      :style="{ backgroundImage: 'url(' + workshop.image + ')' }"
                    />
                  </v-flex> -->
                  <v-flex
                    xs12
                    md10
                    class="mt-2"
                    :style="{'padding-left': getPadding()}"
                  >
                    <div>
                      {{ getDateText() }}
                    </div>
                    <div class="mt-2">
                      {{ getDays() }}
                    </div>
                    <div class="mt-2">
                      {{ getSchedule() }}
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex
              xs6
            >
              <div>
                <span class="subtitle">Datos de la clase</span> 
              </div>
              <div class="mt-2">
                <span class="content-data">{{ "Salón: " + getClassRoomName() }}</span>
              </div>
              <div class="mt-2">
                <span class="content-data">{{ getEmployeeData() }}</span>
              </div>
              <div class="mt-2">
                <span class="content-data">{{ getQuota() }}</span>
              </div>
              <div class="mt-2">
                <span class="content-data">{{ getTag() }}</span>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              class="centerContent"
            >
              <div class="searchBar">
                <v-text-field
                  flat
                  color="black"
                  label="Buscar"
                  append-outer-icon="search"
                  @click:append-outer="filterSearch"
                  @click:clear="filterSearchClear"
                  @keyup.enter="filterSearch"
                  solo-inverted
                  v-model="filters.search"
                  clearable
                  id="password" 
                  name="password" 
                  browser-autocomplete="new-password" 
                />
              </div>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
            >
              <v-data-table
                :headers="headers"
                :rows-per-page-items="[25, 50, 100]"
                :items="students"
                :pagination.sync="pagination"
                :total-items="totalItemsFromBackend"
                item-key="id"
                :no-data-text="students.length > 0 ? '' : 'No hay estudiantes'"
                no-results-text="No hay estudiantes"
                row
                wrap
                ref="table"
              >
                <template v-slot:headers="props">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    class="table-row-size"
                  >
                    {{ header.text }}
                  </th>
                </template>
                <template v-slot:items="props">
                  <td
                    class="table-row-size "
                  >
                    <v-avatar
                      class="mt-2"
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                    >
                      <!-- <img
                        :src="props.item.image"
                        alt="avatar"
                      > -->
                      <v-icon>account_circle</v-icon>
                    </v-avatar>
                  </td>
                  <td
                    class="table-row-size "
                  >
                    {{ props.item.firstName }}
                  </td>
                  <td
                    class="table-row-size "
                  >
                    {{ props.item.lastName }}
                  </td>
                  <td
                    class="table-row-size "
                  >
                    {{ props.item.email }}
                  </td>
                  <td
                    class="table-row-size "
                  >
                    {{ props.item.phone }}
                  </td>
                  <td
                    class="table-row-size "
                  >
                    {{  props.item.enrollmentAt }}
                  </td>
                  <td
                    style="width: 100px !important; max-width: 100px !important; min-width: 100px !important"
                  >
                    <v-icon
                      class="cursor"
                      @click="addStudent(props.item)"
                    >
                      {{ isEnrolled ? "add": "remove" }}
                    </v-icon>
                  </td>
                </template>
                <!-- <template v-slot:headers="props">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    style="width: 16%"
                  >
                    {{ header.text }}
                  </th>
                </template>
                <template v-slot:item="props">
                 {{props}}
                </template> -->
              <!-- <template
                v-slot:pageText="props"
              >
              </template> -->
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- <v-layout>
            <v-flex xs10 />
            <v-flex xs2>
              <v-btn
                small
                color="primary"
                dark
                @click="close"
              >
                Cancelar
              </v-btn>
            </v-flex>
          </v-layout> -->
        </v-container>
      </v-card>
    </v-dialog>
    <simple-confirm
      v-model="confirmStudent"
      :message="messageConfirm"
      @save="confirmSave"
    />
    <success
      v-model="toast.success"
      text="Operación Exitosa"
    />
    <error
      v-model="toast.failed"
      text="Ups ocurrió un error"
    />
    <loading
      v-model="toast.loading"
      text="Trabajando..."
    />
  </div>
</template>

<script>
import moment from 'moment';

import 'vue2-timepicker/dist/VueTimepicker.css';
import { ableDays } from "@/Catalogs/mapSettings";
import { mapGetters } from 'vuex';
import SimpleConfirm from './SimpleConfirm.vue';
import { isEmptyOrNull } from '../../../plugins/GeneralMethods';
import Success from '../../Dialogs/Success.vue';
import Error from '../../Dialogs/Error.vue';
import Loading from '../../Dialogs/Loading.vue';

export default {
    components: {
        SimpleConfirm,
        Error,
        Success,
        Loading
    },
    props: ["value", "workshopEdit", "isEnrolled"],
    data: () => ({
      headers: [
        {
          text: "Foto",
          align: "center",
          value: "image"
        },
        {
          text: "Nombre",
          align: "center",
          value: "firstName"
        },
        {
          text: "Apellidos",
          align: "center",
          value: "lastName"
        },
        {
          text: "Correo",
          align: "center",
          value: "email"
        },
        {
          text: "Teléfono",
          align: "center",
          value: "phone"
        },
        {
          text: "Fecha de inscripción",
          align: "center",
          value: "date"
        },
        {
          text: "Acciones",
          align: "center",
          value: "action"
        },
      ],
      workshop: {
        id: "",
        name:"", 
        description:"", 
        strStartDate:"", 
        strEndDate:"", 
        image:"", 
        days:"", 
        shift:"", 
        room:"", 
        employee:"", 
        quotaLimit:"", 
        tag:"", 
        enrollmentAt: ""
      },
      filters: {
        search: "",
        size: 25,
        offset: 0,
        orderType: "asc",
      },
      confirmStudent: false,
      studentSelected: {},
      students: [],
      messageConfirm: "",
      pagination: {
        descending: false,
        total: 0,
        rowsPerPage: 25
      },
      toast: {
        success: false,
        failed: false,
        loading: false
      },
      totalItemsFromBackend: 0
    }),
    watch: {
      workshopEdit() {
        this.workshop = this.workshopEdit
        this.getEnableStudents()
      },
      isEnrolled(){
        this.workshop = this.workshopEdit
        this.getEnableStudents()
      },
      pagination: {
        handler() {
          this.filters.size = this.pagination.rowsPerPage;
          this.filters.offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
          this.filters.orderBy = this.pagination.sortBy;
          this.filters.orderType = this.pagination.descending ? "DESC" : "ASC";
          this.getEnableStudents();
        },
        deep: true
      }
    },
    computed: {
      dateStartErrors() {
          const errors = [];
          if (!this.$v.workshopForm.strStartDate.$dirty) return errors;
          !this.$v.workshopForm.strStartDate.required && errors.push("Fecha de inicio obligatoria");
          return errors;
      },
      momentFormatStartDate() {
          if (this.strStartDate != null) {
              return moment(this.strStartDate).format("DD/MM/YYYY");
          }
          return "";
      },
      momentFormatEndDate() {
          if (this.strEndDate != null) {
              return moment(this.strEndDate).format("DD/MM/YYYY");
          }
          return "";
      },
      momentFormatStartTime(){
          if (this.scheduleTime != null) {
              return moment(this.scheduleTime).format("DD/MM/YYYY");
          }
          return "";
      },
      enableDays() {
          return ableDays;
      },
      ...mapGetters(["getBranch"]),
    },
    methods: {
      getClassRoomName() {
        if (isEmptyOrNull(this.workshop)){
          return ""
        }
        const classRoom = this.workshop.classroom
        if (!isEmptyOrNull(classRoom)){
          return classRoom.classroomName
        }
        return ""
      },
      getWorkshopName(){
        return isEmptyOrNull(this.workshop) ? "" : this.workshop.name
      },
      getWorkShopDescription(){
        return isEmptyOrNull(this.workshop) ? "" : this.workshop.description
      },
      getEnableStudents(){
        if (isEmptyOrNull(this.workshop) || isEmptyOrNull(this.getBranch.id)){
          return
        }
        const body = {
          courseId: this.workshop.id,
          search: this.filters.search,
          size:  this.filters.size,
          offset:  this.filters.offset,
          orderBy:  this.filters.orderBy,
          orderType:  this.filters.orderType,
        }
        this.toast.loading = true
        if (this.isEnrolled){
          this.$store
            .dispatch("workshop/getStudentsFromWorkShop", body)
            .then((response) => {
              const data = isEmptyOrNull(this.filters.search) ? 
              response.data.entity :
              response.data.entity.filter(it => 
              it.firstName.toLowerCase().includes(this.filters.search.toLowerCase()) ||  
              it.lastName.toLowerCase().includes(this.filters.search.toLowerCase()))              
              this.students = data
              this.toast.loading = false
              this.totalItemsFromBackend = response.data.filters.total
            })
            .catch(error => {
              console.log(error);
              this.toast.loading = false
            });
        }else {
          this.$store
            .dispatch("workshop/getStudentsToEnrolled", body)
            .then((response) => {
                const data = isEmptyOrNull(this.filters.search) ? 
              response.data.entity :
              response.data.entity.filter(it => 
              it.firstName.toLowerCase().includes(this.filters.search.toLowerCase()) ||  
              it.lastName.toLowerCase().includes(this.filters.search.toLowerCase()))              
              this.students = data
              this.toast.loading = false
              this.totalItemsFromBackend = response.data.filters.total
            })
            .catch(error => {
              console.log(error);
              this.toast.loading = false
            });
        }
      },
      close() {
        this.$emit("input", false);
        this.$emit("close", false);
        this.students = []
        this.filters.search = ""
      },
      getDateText(){
        if (isEmptyOrNull(this.workshop)){
          return ""
        }
        return "Inicio: " + 
        this.workshop.strStartDate +
        " | Término: " + 
        this.workshop.strEndDate
        
      },
      getDateWithFormat(format, dateString) {
        return moment(new Date(Number(dateString))).format(format);
      },
      getDays() {
        if (isEmptyOrNull(this.workshop)){
          return ""
        }
        const days = this.workshop.days
        if(days === undefined || days === null){
          return
        }
         const daysSplit = this.workshop.days.split(",")
          var daysString = ""
          ableDays.forEach(it => {
            daysSplit.forEach(day => {
              if(it.name === day) {
                daysString += it.nombre + ", "
              }
            })
          });

        return "Días a impartir: " + daysString
      },
      getSchedule(){
        if (isEmptyOrNull(this.workshop)){
          return ""
        }
        const d = moment(new Date()).format('yyyy-MM-DD'); // d = "12/12/2017"
        const dateStart = moment(d +'T'+ this.workshop.timeSchedule).format();
        const dateEnd = moment(d +'T'+ this.workshop.timeEndSchedule).format();
        var startDate = ""
        var endDate = ""

        if (dateStart != null) {
          console.log(dateStart);
          startDate = moment(dateStart).format("hh:mm a");
        }

        if (dateEnd != null) {
          console.log(dateEnd);
          endDate = moment(dateEnd).format("hh:mm a");
        }
        return "Horario: " + startDate + " - " + endDate + " | " + this.getShift()
        
      },
      getShift(){
        if (isEmptyOrNull(this.workshop)){
          return ""
        }
        if (this.workshop.shift === "M"){
          return "Matutino"
        }
        return "Vespertino"
      },
      getPadding(){
        return (this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly) ? "0" : "30px" 
      },
      getQuota(){
        if (isEmptyOrNull(this.workshop)){
          return ""
        }
        if (this.workshop.quotaLimit === 0){
          return "Cupo: Sin límite"
        }else {
          return "Cupo: " + this.workshop.quotaLimit 
        }
      },
      filterSearchClear(){
        this.filters.search = ""
        this.getEnableStudents()
      },
      filterSearch() {
        this.getEnableStudents()
      },
      addStudent(student) {
        console.log(student);
        this.confirmStudent = true
        this.studentSelected = student
        if(this.isEnrolled){
          this.messageConfirm = "¿Desea inscribir a " + student.firstName + " al taller " + this.workshop.name + "?"
        }else {
          this.messageConfirm = "¿Desea dar de baja a " + student.firstName + " del taller " + this.workshop.name + "?"
        }
      },
      studentWasDeleted(){
        const index = this.workshop.students.findIndex(it => it.id === this.studentSelected.id)
        if (index >= 0) {
          this.workshop.students.pop(index)
        }
      },
      getTag(){
        if (isEmptyOrNull(this.workshop)){
          return ""
        }
        return this.workshop.tags
      },
      getEmployeeData(){
        if (isEmptyOrNull(this.workshop)){
          return ""
        }
        const employee = this.workshop.employee
        if (employee === null || employee === undefined){
          return 
        }
        return "Instructor: " + employee.firstName + " " + employee.lastName 
      },
      confirmSave(){
        const body = {
          course: {
            id: this.workshop.id
          },
          student: {
            id: this.studentSelected.id
          }
        }
        if (this.isEnrolled){
          this.$store
            .dispatch("workshop/enrolledStudent", body)
            .then(() => {
              this.toast.success = true
              this.$emit("reload", true)
              this.getEnableStudents()
            })
            .catch(error => {
              this.toast.failed = true
              console.log(error);
            });
        }else {
          this.$store
            .dispatch("workshop/disenrollStudent", body)
            .then(() => {
              this.toast.success = true
              this.$emit("reload", true)
              this.getEnableStudents()
            })
            .catch(error => {
              this.toast.failed = true
              console.log(error);
            });
        }
      }
    }

};
</script>

<style >
.pickers {
  justify-content: center;
  align-items: center;
  width: 100%
}

.date-picker-notice {
	font-size:1.2em; 
	display: flex;
	justify-content: center;
	align-items: center;
}

.border-class-notice {
	border: 2px solid #757575;
	height: 57px;
	display: flex;

}


.title {
  color: black;
  font-weight: bold;
  font-size: x-large;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.subtitle {
  color: rgb(175, 175, 175);
  font-size: large;
  text-align: left;
}

.content-data {
  color: rgb(0, 0, 0);
  font-size: medium;
  text-align: left;
}

.image-circle{
  width: 75px !important;
  height: 75px !important;
  background: 50% no-repeat;
  background-size: cover;
  border-radius: 50%;
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchBar {
  border-color: black;
  border-width: 2px;
  border-radius: 50px;
  border-style: solid;
  color: black;
  padding-left: 5px;
  padding-right: 5px;
  width: 50%;
  margin-top: 20px;
}

.searchBar .v-input .v-input__slot {
  background-color: transparent !important;
  color: black !important;
  padding: 0%;
  margin: 0%;
}

.searchBar .theme--light.v-input:not(.v-input--is-disabled) input{
  color: black !important;
}

.searchBar .v-text-field__details {
  padding: 0% !important;
  margin: 0% !important;
  display: none !important;
}

.table-row-size {
  width: 16% !important; 
  max-width: 16% !important; 
  min-width: 16% !important;

}
</style>
